export const strings = {
  english: {
    description: 'DESCRIPTION',
    faq: 'FAQ & DOCUMENTATION',
  },
  japan: {
    description: '説明',
    faq: 'よくある質問',
  },
};
